import { formatNumber } from '../../../../helpers/numbers'

export const getFormattedAudiences = audiences => {
  return audiences.map(({ id, name, approximate_count_lower_bound: lowerBound }) => ({
    value: id,
    label: name,
    // if lowerBound is -1 - don't show it
    tag: Number(lowerBound) === -1 ? '' : formatNumber(lowerBound)
  }))
}
